module.exports = __webpack_public_path__ + "img/high_five.4b8ffbce.png";